<template>
    <div id="root" class="quanping" style="position: relative;top:0;height: 100vh;display: flex;align-items: center;justify-content: center;">
        <div class="column pagestyle___3At3P" style="width: 1300px;margin: 0 auto;display: flex;align-items: center;justify-content: center;">
            <form class="ant-form ant-form-horizontal layui-form form-horizontal p-15"
                style="width: 800px; background: rgb(255, 255, 255); border-radius: 20px; padding: 60px 40px; box-shadow: rgba(235, 235, 235, 0.54) 0px 6px 10px 1px;">
                    <div class="row" style="margin-bottom: 20px;">
                        <h2 style="font-size: 18px; color: rgb(21, 21, 21); margin: 0px; flex: 1 1 0%;">欢迎注册</h2>
                    </div>
                    <table class="table table-bordered" style="width: 100%">
                        <tbody>
                            <tr>
                                <td class="width-15 active">
                                    <label class="pull-right">
                                        <span style="color: red;">*</span>姓名：
                                    </label>
                                </td>
                                <td class="width-35">
                                    <div class="ant-form-item-control">
                                        <span class="ant-form-item-children">
                                            <span class="ant-input-affix-wrapper" style="height: 40px;">
                                                <input type="text" name="userName" v-model="userName" id="userName"
                                                    placeholder="请输入姓名" autocomplete="off" class="ant-input"
                                                    maxlength="60">
                                            </span>
                                        </span>
                                    </div>
                                </td>
                                <td class="width-15 active">
                                    <label class="pull-right">
                                        <span style="color: red;">*</span>
                                        身份证号：
                                    </label>
                                </td>
                                <td class="width-35">
                                    <div class="ant-form-item-control">
                                        <span class="ant-form-item-children">
                                            <span class="ant-input-affix-wrapper" style="height: 40px;">
                                                <input type="text" name="idCard" v-model="idCard" placeholder="请输入身份证号"
                                                    autocomplete="off" class="ant-input">
                                            </span>
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td class="width-15 active">
                                    <label class="pull-right">
                                        手机号：
                                    </label>
                                </td>
                                <td class="width-35">
                                    <span class="ant-input-affix-wrapper" style="height: 40px;">
                                        <input required="" type="text" name="telephone" v-model="telephone"
                                            id="telephone" placeholder="请输入手机号" autocomplete="off" class="ant-input">
                                    </span>

                                </td>
                                <td class="width-15 active">
                                    <label class="pull-right">
                                        qq邮箱：
                                    </label>
                                </td>
                                <td class="width-35">
                                    <span class="ant-input-affix-wrapper" style="height: 40px;">
                                        <input type="text" name="email" id="email" v-model="email"
                                            placeholder="请输入qq邮箱 用于密码找回" autocomplete="new-password" class="ant-input">
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td class="width-15 active">
                                    <label class="pull-right">
                                        密码：
                                    </label>
                                </td>
                                <td class="width-35">
                                    <div class="ant-form-item-control">
                                        <span class="ant-form-item-children">
                                            <span class="ant-input-affix-wrapper" style="height: 40px;">
                                                <input type="password" name="password" v-model="password" id="password"
                                                    placeholder="请输入密码" action="click" autocomplete="new-password"
                                                    class="ant-input">
                                            </span>
                                        </span>
                                    </div>
                                </td>
                                <td class="width-15 active">
                                    <label class="pull-right">
                                        用户类型：
                                    </label>
                                </td>
                                <td class="width-35">
                                    <div class="ant-form-item-control">
                                        <el-radio-group v-model="radio">
                                            <el-radio :label="1">院校</el-radio>
                                            <el-radio style="margin-top: 5px;" :label="2">社会</el-radio>
                                        </el-radio-group>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <a class="layui-btn layui-bg-green" @click="signUpRightAway"
                        style="display: inline-block;margin-right: 22px;">立即注册</a>
                    <a href="/" class="layui-btn layui-bg-green shouye"
                        style="display: inline-block;margin-right: 22px;">返回首页</a>
                    <div style="width: 50%; float: left; margin-top: 6px;">
                        <a class="loginPersonal" @click="immediately" style="color: red;">已有账号！立即登录</a>
                    </div>
            </form>
        </div>
    </div>
</template>
<script>
    //import homePage from './components/homePage.vue';
    export default {
        name: 'app',
        components: {
        },
        data() {
            return {
                radio: 1,
                userName: '',
                idCard: '',
                telephone: '',
                email: '',
                password: ''

            }
        },
        created() {
        },
        mounted() {
        },
        methods: {
            //立即注册
            signUpRightAway() {


                var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
                 if (this.userName === '') {
                    this.$message({
                        message: '请输入姓名！',
                        type: 'warning'
                    });

                    return false;
                } else if (this.idCard === '') {
                    this.$message({
                        message: '请输入身份证号',
                        type: 'warning'
                    });
                    return false;
                } else if (this.idCard.length < 18) {
                    this.$message({
                        message: '身份证号位数小于18位！',
                        type: 'warning'
                    });
                    return false;
                }else if (this.telephone === '') {
                    this.$message({
                        message: '请输入手机号',
                        type: 'warning'
                    });
                    return false;
                } else if (this.telephone.length != 11) {
                    this.$message({
                        message: '请输入正确的手机号',
                        type: 'warning'
                    });
                    return false;
                }else  if (this.email!='' && !reg.test(this.email)) {
                    this.$message({
                        message: '请输入正确的邮箱！',
                        type: 'warning'
                    });
                    return false;
                }else if (this.password === '') {
                    this.$message({
                        message: '请输入密码',
                        type: 'warning'
                    });
                    return false;
                }

                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });

                let parames = new URLSearchParams();
                parames.append('userName', this.userName);
                parames.append('idCard', this.idCard);
                parames.append('telephone', this.telephone);
                parames.append('password', this.password);
                parames.append('email', this.email);

                this.$axios.post(this.serverUrl + '/register', parames).then(resp => {
                    loading.close();

                    this.$message({
                        message: resp.data.msg,
                        type: 'warning'
                    });

                    setTimeout(() => {
                        this.$router.push({ path: '/login' });
                    }, 1000);



                }).catch(err => {
                    this.$message({
                        message: '服务器异常！',
                        type: 'warning'
                    });
                });

            },
            //立即登录
            immediately() {
                 this.$router.push('/login');
               // this.$router.push('/bigHomePage')
            }


        }

    }
</script>

<style src="../../static/css/login.css" scoped></style>

<style>
    .quanping {
        position: relative;
        top: 0;
        left: 0;
        width: 100%;
        min-height: calc(100vh - 150px);
        padding-bottom: 100px;
    }

    .wrong {
        border-color: red;
    }

    .ant-form-item-control {
        width: 100%;
        margin-right: 1%;
        display: inline-block;
    }

    /*下拉菜单修改padding-left属性*/
    .layui-input,
    .layui-textarea {
        display: block;
        width: 100%;
        padding-left: 11px;
    }

    .layui-form-select .layui-input {
        padding-right: 30px;
        cursor: pointer;
        border: 1px solid #d9d9d9;
        border-radius: 4px;
        transition: all .3s;
    }

    .layui-input,
    .layui-select,
    .layui-textarea {
        height: 40px;
        line-height: 1.3;
        line-height: 38px \9;
        border-width: 1px;
        border-style: solid;
        background-color: #fff;
        border-radius: 2px;
    }

    /*下拉菜单修改padding-left属性*/
    /*修改滚动条样式*/
    ::-webkit-scrollbar {
        width: 4px;
        height: 10px;
        /**/
    }

    ::-webkit-scrollbar-track {
        background: rgb(239, 239, 239);
        border-radius: 4px;
    }

    ::-webkit-scrollbar-thumb {
        background: #bfbfbf;
        border-radius: 10px;
    }

    ::-webkit-scrollbar-thumb:hover {
        background: #333;
    }

    ::-webkit-scrollbar-corner {
        background: #179a16;
    }

    /*修改滚动条样式*/

    /*table样式*/
    .tree_table>thead>tr>th,
    .table>tbody>tr>th,
    .table>tfoot>tr>th,
    .table>thead>tr>td,
    .table>tbody>tr>td,
    .table>tfoot>tr>td,
    .table-bordered {
        border-top: 1px solid #ebeff2 !important;
    }

    .table {
        margin-bottom: 25px;
    }

    tbody {
        color: #797979;
    }

    .table-striped>tbody>tr:nth-of-type(odd),
    .table-hover>tbody>tr:hover,
    .table>thead>tr>td.active,
    .table>tbody>tr>td.active,
    .table>tfoot>tr>td.active,
    .table>thead>tr>th.active,
    .table>tbody>tr>th.active,
    .table>tfoot>tr>th.active,
    .table>thead>tr.active>td,
    .table>tbody>tr.active>td,
    .table>tfoot>tr.active>td,
    .table>thead>tr.active>th,
    .table>tbody>tr.active>th,
    .table>tfoot>tr.active>th {
        background-color: #f4f8fb !important;
    }

    .tree_table>thead>tr>th,
    .table>tbody>tr>th,
    .table>tfoot>tr>th,
    .table>thead>tr>td,
    .table>tbody>tr>td,
    .table>tfoot>tr>td,
    .table-bordered {
        border-top: 1px solid #ebeff2 !important;
    }

    .table td,
    .table th {
        padding: 8px;
    }

    .width-15 {
        width: 15%;
    }

    .width-35 {
        width: 35%;
    }

    .pull-right {
        float: right;
    }

    table {
        border: 1px solid #ebeff2;
        font-size: 13px;
    }

    /*table样式*/

    /*上传图片框框*/
    .layui-upload-drag {
        position: relative;
        padding: 13px;
        border: 1px dashed #e2e2e2;
        background-color: #fff;
        text-align: center;
        cursor: pointer;
        color: #999;
    }

    /*上传图片框框*/
</style>



// WEBPACK FOOTER //
// src/components/personRegister.vue